import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { FrankensteinMode } from '../modes/abstractMode.js';
import { NULL_LANGUAGE_IDENTIFIER } from '../modes/nullMode.js';
import { LanguagesRegistry } from './languagesRegistry.js';
import { firstOrDefault } from '../../../base/common/arrays.js';

var LanguageSelection = /*#__PURE__*/function (_Disposable) {
  _inherits(LanguageSelection, _Disposable);

  var _super = _createSuper(LanguageSelection);

  function LanguageSelection(onLanguagesMaybeChanged, selector) {
    var _this;

    _classCallCheck(this, LanguageSelection);

    _this = _super.call(this);
    _this._onDidChange = _this._register(new Emitter());
    _this.onDidChange = _this._onDidChange.event;
    _this._selector = selector;
    _this.languageIdentifier = _this._selector();

    _this._register(onLanguagesMaybeChanged(function () {
      return _this._evaluate();
    }));

    return _this;
  }

  _createClass(LanguageSelection, [{
    key: "_evaluate",
    value: function _evaluate() {
      var languageIdentifier = this._selector();

      if (languageIdentifier.id === this.languageIdentifier.id) {
        // no change
        return;
      }

      this.languageIdentifier = languageIdentifier;

      this._onDidChange.fire(this.languageIdentifier);
    }
  }]);

  return LanguageSelection;
}(Disposable);

export var ModeServiceImpl = /*#__PURE__*/function () {
  function ModeServiceImpl() {
    var _this2 = this;

    var warnOnOverwrite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _classCallCheck(this, ModeServiceImpl);

    this._onDidCreateMode = new Emitter();
    this.onDidCreateMode = this._onDidCreateMode.event;
    this._onLanguagesMaybeChanged = new Emitter();
    this.onLanguagesMaybeChanged = this._onLanguagesMaybeChanged.event;
    this._instantiatedModes = {};
    this._registry = new LanguagesRegistry(true, warnOnOverwrite);

    this._registry.onDidChange(function () {
      return _this2._onLanguagesMaybeChanged.fire();
    });
  }

  _createClass(ModeServiceImpl, [{
    key: "isRegisteredMode",
    value: function isRegisteredMode(mimetypeOrModeId) {
      return this._registry.isRegisteredMode(mimetypeOrModeId);
    }
  }, {
    key: "getModeIdForLanguageName",
    value: function getModeIdForLanguageName(alias) {
      return this._registry.getModeIdForLanguageNameLowercase(alias);
    }
  }, {
    key: "getModeIdByFilepathOrFirstLine",
    value: function getModeIdByFilepathOrFirstLine(resource, firstLine) {
      var modeIds = this._registry.getModeIdsFromFilepathOrFirstLine(resource, firstLine);

      return firstOrDefault(modeIds, null);
    }
  }, {
    key: "getModeId",
    value: function getModeId(commaSeparatedMimetypesOrCommaSeparatedIds) {
      var modeIds = this._registry.extractModeIds(commaSeparatedMimetypesOrCommaSeparatedIds);

      return firstOrDefault(modeIds, null);
    }
  }, {
    key: "getLanguageIdentifier",
    value: function getLanguageIdentifier(modeId) {
      return this._registry.getLanguageIdentifier(modeId);
    } // --- instantiation

  }, {
    key: "create",
    value: function create(commaSeparatedMimetypesOrCommaSeparatedIds) {
      var _this3 = this;

      return new LanguageSelection(this.onLanguagesMaybeChanged, function () {
        var modeId = _this3.getModeId(commaSeparatedMimetypesOrCommaSeparatedIds);

        return _this3._createModeAndGetLanguageIdentifier(modeId);
      });
    }
  }, {
    key: "createByFilepathOrFirstLine",
    value: function createByFilepathOrFirstLine(resource, firstLine) {
      var _this4 = this;

      return new LanguageSelection(this.onLanguagesMaybeChanged, function () {
        var modeId = _this4.getModeIdByFilepathOrFirstLine(resource, firstLine);

        return _this4._createModeAndGetLanguageIdentifier(modeId);
      });
    }
  }, {
    key: "_createModeAndGetLanguageIdentifier",
    value: function _createModeAndGetLanguageIdentifier(modeId) {
      // Fall back to plain text if no mode was found
      var languageIdentifier = this.getLanguageIdentifier(modeId || 'plaintext') || NULL_LANGUAGE_IDENTIFIER;

      this._getOrCreateMode(languageIdentifier.language);

      return languageIdentifier;
    }
  }, {
    key: "triggerMode",
    value: function triggerMode(commaSeparatedMimetypesOrCommaSeparatedIds) {
      var modeId = this.getModeId(commaSeparatedMimetypesOrCommaSeparatedIds); // Fall back to plain text if no mode was found

      this._getOrCreateMode(modeId || 'plaintext');
    }
  }, {
    key: "_getOrCreateMode",
    value: function _getOrCreateMode(modeId) {
      if (!this._instantiatedModes.hasOwnProperty(modeId)) {
        var languageIdentifier = this.getLanguageIdentifier(modeId) || NULL_LANGUAGE_IDENTIFIER;
        this._instantiatedModes[modeId] = new FrankensteinMode(languageIdentifier);

        this._onDidCreateMode.fire(this._instantiatedModes[modeId]);
      }

      return this._instantiatedModes[modeId];
    }
  }]);

  return ModeServiceImpl;
}();